export default "__VITE_ASSET__Wj340wVR__"